import { ReactComponent as DarkLightSvg } from "./light-dark-mode.svg";
const DarkLightIcon = (props) => {
  return <DarkLightSvg {...props} />;
};
export default DarkLightIcon;
